import { useRef, useEffect, useState } from "react";
import './Toast.css';
function Toast({title, children, type, index, id, duration, deleteTime}) {
    
    useEffect(() => {
        setTimeout( () => {
            const progressBarRef = document.querySelector(`#notification_${id} #bar`)
            if(!progressBarRef) {
                return;
            }
            progressBarRef.className = 'start'
        }, 50);

        if(deleteTime != 0) {
            return;
        }

        setInterval( () => {
            const progressBarRef = document.querySelector(`#notification_${id} #bar`)
            if(!progressBarRef) {
                return;
            }
            progressBarRef.className = ''
            progressBarRef.style.transition = ''

            setTimeout(() => {
                progressBarRef.style.transition = "width ease " + duration + "ms"
                progressBarRef.className = 'start'
            }, 100)
        }, duration);

    }, [])

    useEffect(() => {

        setInterval(reloadNotificationPosition, 50)
        if(deleteTime == 0) {
            return;
        }

        setTimeout( () => {
            const notificationRef = document.getElementById("notification_" + id)
            if(!notificationRef) {
                return;
            }
            notificationRef.className = "notification " + type + " disappear"
        }, deleteTime - 250);
        
    }, [deleteTime])

    const reloadNotificationPosition = () => {
        const element = document.getElementById("notification_" + id );
        if(!element) return;
        const {bottom, right} = getOffset();
        

        element.style.bottom = bottom + "px";
        element.style.right = right + "px";
    }

    const getOffset = () => {
        const chatbox = document.querySelector('.kwalys-chatbox-window.visible')
        const offsetBottom = chatbox ? 570 : 20;
        const window = document.getElementsByClassName('editor-window').item(0);
        const windowChannelWeb = document.getElementsByClassName('channel-web-window').item(0);

        const offsetRight = window ? 490 : (windowChannelWeb ? 520 : 20);
        const bottom = offsetBottom + (index * 110);
        const right = offsetRight;
        return { bottom, right }
    }

    const { bottom, right } = getOffset();

    return (
        <div id={"notification_" + id } className={"notification " + type} style={{maxWidth : 500, bottom, right}} >
            <div className="progress-bar">
                <div id="bar" style={{transition: "width ease " + duration + "ms"}}></div>
            </div>
                <span className='title'>{title}</span>
                <p className="desc">{children}</p>
        </div>
    )
}

Toast.defaultProps = { type : 'success', title : 'Default Text' };

export default Toast;